import { render } from "./GalleryList.vue?vue&type=template&id=58510db4&scoped=true"
import script from "./GalleryList.vue?vue&type=script&lang=js"
export * from "./GalleryList.vue?vue&type=script&lang=js"

import "./GalleryList.vue?vue&type=style&index=0&id=58510db4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58510db4"]])

export default __exports__